import Vue from 'vue';
import VueI18n, { LocaleMessages } from 'vue-i18n';
import { brandContext } from './constants/locales';

Vue.use(VueI18n);

function loadLocaleMessages(): LocaleMessages {
  const localesAudi = require.context('./locales/audi', true, /\.json$/);
  const localesCupra = require.context('./locales/cupra', true, /\.json$/);
  const localesVolkswagen = require.context('./locales/volkswagen', true, /\.json$/);
  const messages: LocaleMessages = {};

  switch (brandContext) {
    case 'Cupra': {
      localesCupra.keys().forEach((key) => {
        const matched = key.match(/([a-z-]+)\./i);
        if (matched && matched.length > 1) {
          const locale = matched[1];
          messages[locale] = localesCupra(key);
        }
      });
      break;
    }
    case 'Volkswagen': {
      localesVolkswagen.keys().forEach((key) => {
        const matched = key.match(/([a-z-]+)\./i);
        if (matched && matched.length > 1) {
          const locale = matched[1];
          messages[locale] = localesVolkswagen(key);
        }
      });
      break;
    }
    default: {
      localesAudi.keys().forEach((key) => {
        const matched = key.match(/([a-z-]+)\./i);
        if (matched && matched.length > 1) {
          const locale = matched[1];
          messages[locale] = localesAudi(key);
        }
      });
      break;
    }
  }

  return messages;
}

// Fallback from xy-AB => xy => en, if not overridden on component level with market information
export default new VueI18n({
  locale: navigator.language,
  fallbackLocale: 'en',
  silentFallbackWarn: true,
  messages: loadLocaleMessages()
});
